import React from "react";
import Navbar from "../../components/Navbar/Navbar";
import { useEffect } from "react";
import ScrollToTopButton from "../../components/ScrollToTopButton/ScrollToTopButton";
import DarkModeButton from "../../components/DarkModeButton/DarkModeButton";
import "./PrivacyPolicy.css";

export default function PrivacyPolicy() {

  useEffect(() => {
    document.title = "Kút Online - Adatkezelési tájékoztató";
  }, []);

  return (
    <div>
      <Navbar />
      <DarkModeButton/> 

<div className="page-container p-4" >
   <h1 className="adatkezelesi">Jogi nyilatkozat - Impresszum és Adatvédelem</h1>
     <br/>
    <p><strong>Hatályos: 2025. szeptember 1-től</strong></p>
  </div>
        <div className="page-container p-4" >
          <h1 className="adatkezelesi">Impresszum</h1>
          <p><strong>Kiadó:</strong> Dunántúli Népművészeti Egyesület</p>
          <p><strong>Email cím:</strong> dunantulinepmuveszetiegyesulet@gmail.com</p>
          <p><strong>Adószám:</strong> 19419365-1-18</p>
          <p><strong>Székhely:</strong> 9700 Szombathely, Kisfaludy Sándor utca 25.</p>
          <p><strong>Kiadásért felelős személy:</strong> Sipos Hanna Rut</p>
          <p><strong>Szerkesztésért felelős személy:</strong> Palenik Vendel</p>
          <p><strong>Telefonszám:</strong> +36 70 207 8479</p>
          <p><strong>Tárhelyszolgáltató:</strong> DotRoll Kft. (1148 Budapest, Fogarasi út 3-5.)</p>
          <p><strong>Szerzői jogokra vonatkozó információk:</strong> A weboldalon található tartalmak szerzői jogvédelem alatt állnak. A tartalmak másolása, terjesztése, felhasználása kizárólag a Dunántúli Népművészeti Egyesület írásos engedélyével lehetséges.</p>
        </div>

      <div class="page-container p-4">
        <h1 class="adatkezelesi">Adatkezelési tájékoztató</h1>

        <h2>1. Az adatkezelő adatai</h2>
        <p>
            Név: Dunántúli Népművészeti Egyesület<br/>
            Adószám: 19419365-1-18<br/>
            Székhely: 9700 Szombathely, Kisfaludy Sándor utca 25.<br/>
            Számlaszám: 16200687-10007273<br/>
            E-mail: dunantulinepmuveszetiegyesulet@gmail.com<br/>
            Telefonszám: +36 70 207 8479<br/>
        </p>

        <h2>2. A kezelt adatok köre</h2>
        <ul>
            <li>Teljes név</li>
            <li>E-mail cím</li>
            <li>Kapcsolatfelvételi téma</li>
            <li>Üzenet tartalma</li>
            <li>Hírlevélre való feliratkozási szándék</li>
        <li>Programok iránti érdeklődés</li>
        <li>Az oldal látogatásának gyakorisága</li>
        </ul>

        <h2>3. Az adatkezelés célja</h2>
        <ul>
            <li>Kapcsolatfelvétel, kérdések megválaszolása</li>
            <li>Hírlevél küldése, ha az érintett ehhez hozzájárult</li>
            <li>Felhasználói visszajelzések és vélemények kezelése</li>
            <li>Statisztikai elemzések, a szolgáltatás fejlesztése</li>
            <li>Rendezvényekkel kapcsolatos tájékoztatás</li>
        </ul>

        <h2>4. Az adatkezelés jogalapja</h2>
        <p>
            Az adatkezelés jogalapja az érintett önkéntes, konkrét és tájékozott hozzájárulása (GDPR 6. cikk (1) bekezdés a) pont), valamint jogos érdek (GDPR 6. cikk (1) f) pont), ha a kapcsolatfelvétel az adatkezelő kezdeményezésére történik.
        </p>

        <h2>5. Az adatok megőrzési ideje</h2>
        <p>
            A személyes adatokat az adatkezelés céljának megszűnéséig, vagy a hozzájárulás visszavonásáig őrizzük meg. Hírlevél esetén a leiratkozásig, egyéb esetben maximum 10 évig.
        </p>

        <h2>6. Adattovábbítás és adatfeldolgozók</h2>
        <p>
            Az adatokat harmadik fél részére nem továbbítjuk, kivéve ha jogszabály kötelezővé teszi, vagy ha a weboldalt kiszolgáló technikai szolgáltatók (pl. tárhelyszolgáltató, e-mail szolgáltató) szükségszerűen hozzáférnek azokhoz adatfeldolgozóként.
        </p>
        <p>
            Weboldalunk technikai üzemeltetését a <strong>DotRoll Kft.</strong> (székhely: 1148 Budapest, Fogarasi út 3-5., weboldal: <a href="https://dotroll.com/hu/" rel="noreferrer" target="_blank">https://dotroll.com/hu/</a>) biztosítja tárhelyszolgáltatóként. A DotRoll Kft. nem fér hozzá az Ön személyes adataihoz, mivel azokat kizárólag titkosított módon, automatizált rendszerek kezelik, és az adatkezelés kizárólag az Egyesület által történik.
        </p>

            <h2>7. Az érintettek jogai</h2>
        <ul>
            <li>Tájékoztatást kérhet a kezelt személyes adatokról</li>
            <li>Hozzáférést kérhet saját adataihoz</li>
            <li>Kérheti adatai helyesbítését vagy törlését</li>
            <li>Kérheti az adatkezelés korlátozását</li>
            <li>Visszavonhatja hozzájárulását bármikor</li>
            <li>Tiltakozhat jogos érdeken alapuló adatkezelés ellen</li>
            <li>Jogorvoslattal élhet a Nemzeti Adatvédelmi és Információszabadság Hatóságnál (NAIH – <a href="https://www.naih.hu" target="_blank" rel="noreferrer">www.naih.hu</a>)</li>
        </ul>

        <h2>8. Kapcsolat</h2>
        <p>
            Amennyiben kérdése van az adatkezeléssel kapcsolatban, írjon nekünk az <a href="mailto:kutonlineujsag@gmail.com">kutonlineujsag@gmail.com</a> e-mail címre, vagy keressen bennünket postai úton az egyesület székhelyén.
        </p>
        <p>&copy; 2025 Dunántúli Népművészeti Egyesület</p>
      </div>
      <ScrollToTopButton />
    </div>
  );
}